// modal bloat: show, open, hide
import {useCallback, useState} from "react";

const useModalControls = (defaultShow) => {
    const [show, setShow] = useState(defaultShow ?? false);
    const openModal = useCallback((e) => {
        e?.preventDefault();
        e?.stopPropagation();
        setShow(true);
    }, []);

    const hideModal = useCallback((e) => {
        e?.preventDefault?.();
        e?.stopPropagation?.();
        setShow(false);
    }, []);

    return [show, openModal, hideModal];
};

export default useModalControls;
